export const formatNumber = (
  locale: string,
  value: number,
  options: Intl.NumberFormatOptions,
) => {
  return new Intl.NumberFormat(locale, options).format(value);
};

export const formatPhoneNumberRaw = (phoneNumber: string) => {
  return `+${phoneNumber
    .replace(/\s/g, '')
    .replace(/\)/g, '')
    .replace(/\(/g, '')
    .replace(/-/g, '')
    .replace(/^\+/, '')}`;
};
